import { render } from "./App.vue?vue&type=template&id=23a1fc7c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23a1fc7c&lang=css"
import "./App.vue?vue&type=style&index=1&id=23a1fc7c&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__